export function getHighlightColor(i: number) {
	return `hsla(${(i * 54 + 220) % 360}, 30%, 50%, 0.5)`;
}

export function getWebHighlightColor(i: number) {
	return `hsla(${(i * 54 + 30) % 360}, 40%, 50%, 0.5)`;
}
